import React, { Fragment } from "react";
import { firstError, hasError } from "common/validation";
import { useTranslation } from "react-i18next";
import { useLanguages } from "../use-languages";

import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import Categories from "./Categories";
import CustomizableTextField from "../../general-components/CustomizableTextField";
import CustomizableSelect from "../../general-components/CustomizableSelect";
import PublicationDate from "./PublicationDate";
import CustomizableRichTextField from "../../general-components/CustomizableRichTextField";
import { path } from "ramda";

const AlbumDetailsFields = ({ errors, fields, onBlur, onFieldChange }) => {
  const { t } = useTranslation();
  const languages = useLanguages();

  return (
    <Fragment>
      <Grid container spacing={2}>
        <CustomizableTextField
          id="album-title"
          xs={12}
          sm={3}
          name="title"
          fieldOption="title"
          defaultLabel={t("file_details.title", "Title")}
          value={fields.title || ""}
          onChange={onFieldChange(["title"])}
          error={hasError(errors, "title")}
          helperText={t(firstError(errors, "title"))}
          onBlur={onBlur("title", fields.title)}
          inputProps={{ maxLength: 2048, id: "album-title" }}
        />

        <CustomizableTextField
          id="album-subtitle"
          xs={12}
          sm={3}
          name="subtitle"
          fieldOption="subtitle"
          defaultLabel={t("file_details.subtitle", "Subtitle (optional)")}
          value={fields.subtitle || ""}
          onChange={onFieldChange(["subtitle"])}
          error={hasError(errors, "subtitle")}
          helperText={t(firstError(errors, "subtitle"))}
          onBlur={onBlur("subtitle", fields.subtitle)}
          inputProps={{ maxLength: 255, id: "album-subtitle" }}
        />

        <CustomizableSelect
          xs={12}
          sm={3}
          fieldOption="language"
          defaultLabel={t("file_details.language", "Language")}
          value={fields.language || ""}
          onChange={onFieldChange(["language"])}
        >
          {languages.map(lang => (
            <MenuItem key={lang.code} value={lang.code}>
              {lang.translation}
            </MenuItem>
          ))}
        </CustomizableSelect>

        <PublicationDate />

        <CustomizableRichTextField
          id="description"
          fieldOption="description"
          xs={12}
          sm={12}
          md={12}
          defaultLabel={t("file_details.description", "Description")}
          value={path(["descriptionText"], fields) || ""}
          onChange={({ text, html }) => {
            if (text === "") {
              onFieldChange(["description"])("");
              onFieldChange(["descriptionText"])("");
            } else {
              onFieldChange(["description"])(text);
              onFieldChange(["descriptionText"])(html);
            }
          }}
          error={hasError(errors, "description")}
          helperText={t(firstError(errors, "description"))}
          onBlur={onBlur("description", fields.description)}
        />

        <Grid item xs={12} sm={6}>
          <Categories onBlur={onBlur} />
        </Grid>

        <CustomizableTextField
          multiline
          id="album-keywords"
          fieldOption="keywords"
          xs={12}
          sm={6}
          name="keywords"
          defaultLabel={t("file_details.keywords", "Keywords (optional)")}
          value={fields.keywords || ""}
          onChange={onFieldChange(["keywords"])}
          error={hasError(errors, "keywords")}
          helperText={
            t(firstError(errors, "keywords")) ||
            t(
              "file_details_keywords_helper_text",
              "Keywords should be separated by commas"
            )
          }
          onBlur={onBlur("keywords", fields.keywords)}
          inputProps={{ maxLength: 1000, id: "album-keywords" }}
        />
      </Grid>
    </Fragment>
  );
};

export default AlbumDetailsFields;
